(function() {
  'use strict';

  window.Coop = window.Coop || { Modules: {} };

  Coop.Modules.LocationServiceDriver = {
    defaults: {
      endpoint: window.LOCATION_API
    },
    init: function() {
      window.locationService = this;
      this.is_colleague = $('body').hasClass('colleague-finder');
    },
    getStores: function(businessType, params, callback) {
      var fullEndpoint = this.defaults.endpoint + businessType + '/';

      if(this.is_colleague) {
        params.private = true;
      }

      if (!params.hasOwnProperty('location')) {
        $('.finder-form').trigger('processingDone');
        locationSearch.addBasicErrorMessage('There was a problem with your search, try again');
        return;
      }

      if (!params.format) {
        params.format = 'json';
      }

      $.ajax({
        url: fullEndpoint,
        dataType: 'json',
        data: params,
        success: function(data) {
          callback(data);
        },
        error: function(xhr, error) {
          $('.finder-form').trigger('processingDone');
          locationSearch.addBasicErrorMessage('There was a problem with your search, try again');
        }
      });
    }
  };
})();
